<div class="container">
    <div class="header">
        <div class="session-title">
            <span class="fontfix">{{lecName}}</span><span class="flotR">Session Duration: 1 hour</span>
        </div>
        <div class="session-tags">
            <span class="tag">Live Session</span>
            <span class="tag">Online</span>
            <!-- <span class="tag">Certification</span> -->
        </div>
    </div>
    <!-- FILTER ROW -->
    <div class="filter-row">
        <!-- <div class="filter active">INDICATES</div> -->
        <div class="d-flex">
            <div class="filter d-flex">
                <div class="ava"></div><span style="color:rgb(102, 102, 102)" class="avas">AVAILABLE SLOT</span>
            </div>
            <div class="filter d-flex pddL">
                <div class="notava"></div><span style="color:rgb(102, 102, 102)" class="notavas">NOT AVAILABLE
                    SLOT</span>
            </div>
        </div>
    </div>
    <!-- DATE ROW -->
    <div class="date-row">
        <div class="date-box" *ngFor="let day of days; let i=index" [class.active]="i === selectedIndex"
            (click)="selectDay(i)">
            <div class="day">{{day.day}}</div>
            <div class="date">{{day.date}}</div>
            <div class="month">{{day.month}}</div>
        </div>
    </div>
    <!-- SESSION LIST -->
    <div class="session-container" *ngIf="selectedSessions.length !== 0">
        <div class="session-card" *ngFor="let session of selectedSessions">
            <div class="right">
                <button class="slot"
                    [ngClass]="{'slot-full': session.availableSeats === 0 || isPastSession(session.slotTime, days[selectedIndex].full)}"
                    [disabled]="session.availableSeats === 0 || isPastSession(session.slotTime, days[selectedIndex].full)"
                    (click)="openmodel(session.slotTime, session.sessionId, lecName, session.availableSeats,days[selectedIndex].full)">

                    <span>{{session.slotTime}}</span>
                </button>
            </div>

        </div>
    </div>
    <div class="session-container" *ngIf="selectedSessions.length === 0">
        <app-nodata-found></app-nodata-found>
    </div>

</div>
<div class="modal-overlay" *ngIf="openModel">
    <div class="modal-content">
        <button class="close-button" (click)="closemodel()">&times;</button>
        <app-slot-confirmation [bookSlotInfo]="data" [modulename]="courseData"></app-slot-confirmation>
    </div>
</div>